import React from "react";
const D = window.SiteData;
/* =========================================================
   珂玺资本 — Main pages: Home, About, Strategy
   ========================================================= */

const { useState: useStateM, useEffect: useEffectM } = React;

function fileUrlMain(key) {
  if (!key) return "";
  if (/^https?:\/\//.test(key) || key.startsWith("/")) return key;
  return `/api/files/${key}`;
}

// =========================================================
// HOME / LANDING
// =========================================================
function HomePage({ lang, setRoute, onLoginClick }) {
  const t = (keyOrCn, en) => {
    if (typeof keyOrCn === "string" && keyOrCn.indexOf(".") > 0 && window.I18N) {
      const [ns, k] = keyOrCn.split(".", 2);
      const val = window.I18N[lang] && window.I18N[lang][ns] && window.I18N[lang][ns][k];
      if (val !== undefined) return val;
    }
    // fallback: 兼容旧 t(cn, en) 调用
    return lang === "cn" ? keyOrCn : (en !== undefined ? en : keyOrCn);
  };
  const ti = (k) => D.i18n[lang][k];
  const { user } = window.useAuth();

  return (
    <div className="page" data-screen-label="01 Home">

      {/* HERO */}
      <section className="hero">
        <div className="hero-bg"></div>
        <div className="hero-side" aria-hidden>
          <div className="hero-side-glyph">玺</div>
        </div>
        <div className="container-wide hero-inner">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "center" }}>
            <div>
              <div className="eyebrow" style={{ marginBottom: 28 }}>
                {t('main.t001')}
              </div>
              {lang === "cn" ? (
                <h1 className="hero-cn-stack">
                  <div style={{ whiteSpace: "nowrap" }}>{t('main.heroL1')}</div>
                  <div style={{ whiteSpace: "nowrap" }}>{t('main.heroL2a')}<span className="accent">{t('main.heroL2b')}</span></div>
                </h1>
              ) : (
                <h1 className="hero-cn-stack" style={{ fontFamily: "var(--f-serif-en)", fontSize: "clamp(56px, 7vw, 110px)", fontStyle: "italic", letterSpacing: "-0.01em" }}>
                  <div>{t('main.heroL1')}</div>
                  <div><span className="accent">{t('main.heroL2a')}</span> {t('main.heroL2b')}</div>
                </h1>
              )}
              <div className="hero-en">
                {lang === "cn" ? D.brand.tagline.cn : D.brand.tagline.en}
              </div>
              <p className="hero-sub">{ti("heroBody")}</p>
              <div className="hero-cta">
                <button className="btn" onClick={() => setRoute("cases")}>
                  {t('main.t002')}
                </button>
                <button className="btn btn-ghost" onClick={user ? () => setRoute("dashboard") : onLoginClick}>
                  {user ? (lang === "cn" ? "用户中心" : "Dashboard") : ti("investorLogin")}
                </button>
              </div>
            </div>

            {/* Hero side panel: numbers */}
            <div style={{ position: "relative", paddingLeft: 60, borderLeft: "1px solid var(--line)" }}>
              <div className="mono" style={{ color: "var(--mute-2)", marginBottom: 32, letterSpacing: "0.18em" }}>
                {t('main.t003')}
              </div>
              {[
                { label: t('main.t004'), value: t('main.heroN1'), unit: t('main.heroU1'), vKey: "main.heroN1", uKey: "main.heroU1" },
                { label: t('main.t005'), value: t('main.heroN2'), unit: t('main.heroU2'), vKey: "main.heroN2", uKey: "main.heroU2" },
                { label: t('main.t007'), value: t('main.heroN3'), unit: t('main.heroU3'), vKey: "main.heroN3", uKey: "main.heroU3" },
                { label: t('main.t009'), value: t('main.heroN4'), unit: t('main.heroU4'), vKey: "main.heroN4", uKey: "main.heroU4" },
              ].map((s, i) => (
                <div key={i} style={{
                  display: "grid",
                  gridTemplateColumns: "minmax(110px, auto) 1fr",
                  alignItems: "baseline",
                  gap: 24,
                  padding: "24px 0",
                  borderBottom: i < 3 ? "1px solid var(--line-2)" : "none",
                }}>
                  <div style={{ fontFamily: "var(--f-serif-en)", fontSize: 48, color: "var(--gold)", lineHeight: 1, whiteSpace: "nowrap" }}>
                    <Counter to={s.value} suffix={s.unit} numFixed={s.vKey} suffixFixed={s.uKey} bilingual />
                  </div>
                  <div style={{ color: "var(--mute)", fontSize: 13, letterSpacing: "0.02em" }}>{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </section>

      {/* Listed marquee */}
      <ListedMarquee lang={lang} />

      {/* About teaser */}
      <section className="section">
        <div className="container-wide">
          <SectionHead
            lang={lang}
            num={t('main.num01')}
            kicker={t('main.kFirm')}
            title={t('main.t011')}
            lead={t('main.t012')}
          />
          <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr", gap: 60, alignItems: "stretch" }}>
            <EditableImage
              url={D.about?.homeImage?.url} fit={D.about?.homeImage?.fit}
              cpath="site_data.about.homeImage"
              label={t('main.t013')} kind="skyline" style={{ minHeight: 460 }} />
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", padding: "24px 0" }}>
              <div>
                <div className="eyebrow-mute" style={{ marginBottom: 16 }}>{t('main.t014')}</div>
                <div className="h-2" data-cpath-fixed="main.brandNameCn" style={{ color: "var(--ivory)" }}>{t('main.brandNameCn')}</div>
                <div className="serif-en" data-cpath-fixed="main.brandNameEn" style={{ color: "var(--gold)", marginTop: 12, fontSize: 22 }}>{t('main.brandNameEn')}</div>
                <p className="body-lg body-mute" style={{ marginTop: 28 }}>
                  {t('main.t015')}
                </p>
              </div>
              <div style={{ marginTop: 40 }}>
                <button className="text-link" onClick={() => setRoute("about")}>
                  {t('main.t016')} →
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="section section-tight" style={{ paddingTop: 0 }}>
        <div className="container-wide">
          <StatGrid lang={lang} />
        </div>
      </section>

      {/* Sectors */}
      <section className="section" style={{ background: "var(--bg-0)" }}>
        <div className="container-wide">
          <SectionHead
            lang={lang}
            num={t('main.num02')}
            kicker={t('main.kSectors')}
            title={t('main.t017')}
            lead={t('main.t018')}
            action={
              <button className="text-link" onClick={() => setRoute("strategy")}>
                {t('main.t019')} →
              </button>
            }
          />
          <div className="sector-grid">
            {D.sectors.map((s, si) => (
              <div className="sector-cell" key={s.num}>
                <div className="num">— {s.num}</div>
                <div className="name">{lang === "cn" ? s.cn : s.en}</div>
                {lang === "cn" && <div className="name-en" data-cpath-fixed={`main.secSub${si + 1}`}>{t('main.secSub' + (si + 1))}</div>}
                <div className="desc">{lang === "cn" ? s.desc.cn : s.desc.en}</div>
                <div className="examples" data-cpath-fixed={`main.secEx${si + 1}`}>
                  {t('main.secEx' + (si + 1))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Featured cases */}
      <section className="section">
        <div className="container-wide">
          <SectionHead
            lang={lang}
            num={t('main.num03')}
            kicker={t('main.kListed')}
            title={t('main.t020')}
            action={
              <button className="text-link" onClick={() => setRoute("cases")}>
                {t('main.t021')} →
              </button>
            }
          />
          <FeaturedCases lang={lang} />
        </div>
      </section>

      {/* Pipeline marquee */}
      <section style={{ background: "var(--bg-0)", padding: "60px 0", borderTop: "1px solid var(--line)", borderBottom: "1px solid var(--line)" }}>
        <div className="container-wide">
          <div className="section-head" style={{ marginBottom: 32 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", marginBottom: 24 }}>
              <div>
                <div className="num" data-cpath-fixed="main.num04b" data-cms-neutral>{t('main.num04b')}</div>
                <div className="kicker" style={{ marginTop: 8 }}>{t('main.kPipeline')}</div>
              </div>
              <button className="text-link" onClick={() => setRoute("portfolio")}>{t('main.t022')} →</button>
            </div>
            <h2 className="h-1">{t('main.t023')}</h2>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 0, border: "1px solid var(--line)" }}>
            {D.pipeline.map((p, i) => {
              const n = i + 1;
              const f = (k) => `main.pipe${n}_${k}`;
              const v = (k) => t(`main.pipe${n}_${k}`);
              return (
              <div key={i} style={{
                padding: 28,
                borderRight: i < D.pipeline.length - 1 ? "1px solid var(--line)" : "none",
                transition: "background .3s",
                display: "flex", flexDirection: "column", minHeight: 180,
              }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(201,168,107,0.04)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              >
                <div className="mono" style={{ color: "var(--gold)", marginBottom: 16 }}>↗ <span data-cpath-fixed={f("year")}>{v("year")}</span></div>
                <div data-cpath-fixed={f("title")} style={{ fontFamily: "var(--f-serif-cn)", fontSize: 20, fontWeight: 500 }}>{v("title")}</div>
                <div className="mono" data-cpath-fixed={f("sector")} style={{ color: "var(--mute-2)", marginTop: 8, fontSize: 10, letterSpacing: "0.08em", flex: 1 }}>
                  {v("sector")}
                </div>
                <div data-cpath-fixed={f("status")} style={{ color: "var(--mute)", fontSize: 13, marginTop: 16, lineHeight: 1.5 }}>
                  {v("status")}
                </div>
              </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Philosophy excerpt */}
      <section className="section">
        <div className="container-wide">
          <SectionHead
            lang={lang}
            num={t('main.num05')}
            kicker={t('main.kPhilosophy')}
            title={t('main.t024')}
            lead={t('main.t025')}
            leadWide
          />
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 0, borderTop: "1px solid var(--line)", borderLeft: "1px solid var(--line)" }}>
            {D.philosophy.map((p, pi) => (
              <div key={p.num} style={{
                padding: 40,
                borderRight: "1px solid var(--line)",
                borderBottom: "1px solid var(--line)",
                aspectRatio: "1 / 1.1",
                display: "flex", flexDirection: "column", justifyContent: "space-between",
                cursor: "pointer", transition: "background .4s",
              }}
              onMouseEnter={e => e.currentTarget.style.background = "rgba(201,168,107,0.04)"}
              onMouseLeave={e => e.currentTarget.style.background = "transparent"}
              >
                <div data-cpath-fixed={`main.philoNum${pi + 1}`} style={{ fontFamily: "var(--f-serif-en)", fontSize: 56, color: "var(--gold)", fontStyle: "italic", lineHeight: 1 }}>{t('main.philoNum' + (pi + 1))}</div>
                <div>
                  <div style={{ fontFamily: "var(--f-serif-cn)", fontSize: 22, fontWeight: 500 }}>{lang === "cn" ? p.cn : p.en}</div>
                  {lang === "cn" && <div className="serif-en" data-cpath-fixed={`main.philoSub${pi + 1}`} style={{ color: "var(--mute)", fontSize: 13, marginTop: 4 }}>{t('main.philoSub' + (pi + 1))}</div>}
                  <p style={{ color: "var(--mute)", fontSize: 13, marginTop: 16, lineHeight: 1.7 }}>{lang === "cn" ? p.body.cn : p.body.en}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section style={{ background: "var(--bg-0)", padding: "120px 0" }}>
        <div className="container-wide" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "center" }}>
          <div>
            <div className="eyebrow">{t('main.t026')}</div>
            <h2 className="h-1" style={{ marginTop: 24, lineHeight: 1.15 }}>
              {t('main.t027')}<br />
              {lang === "cn"
                ? <span data-cpath-fixed="main.collabL2" style={{ color: "var(--gold)" }}>{t('main.collabL2')}</span>
                : <span data-cpath-fixed="main.collabL2" className="serif-en" style={{ color: "var(--gold)" }}>{t('main.collabL2')}</span>}
            </h2>
            <p className="body-lg body-mute" style={{ marginTop: 28, maxWidth: 460 }}>
              {t('main.t028')}
            </p>
          </div>
          <div>
            <div className="contact-info">
              <div className="contact-item">
                <div className="label">{t('main.t029')}</div>
                <div className="value">{lang === "cn" ? D.contact.person.cn : D.contact.person.en}</div>
                <div className="value-en">{t('common.t028')}</div>
              </div>
              <div className="contact-item">
                <div className="label">{t('main.t030')}</div>
                <div className="value">{D.contact.phone}</div>
              </div>
              <div className="contact-item">
                <div className="label">{t('main.t031')}</div>
                <div className="value" style={{ fontSize: 18 }}>{lang === "cn" ? D.contact.addr.cn : D.contact.addr.en}</div>
              </div>
              <button className="btn" style={{ alignSelf: "flex-start" }} onClick={() => setRoute("contact")}>
                {t('main.t032')}
                <span className="arr"></span>
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

// ----- featured cases (top 3) on home -----
function FeaturedCases({ lang }) {
  const t = (k) => { const [ns, key] = k.split("."); return (window.I18N?.[lang]?.[ns]?.[key]) ?? k; };
  const featured = D.listed.slice(0, 3);
  // featured 取自 D.listed 前 3 条，索引与 D.listed 一致
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 1, background: "var(--line)", border: "1px solid var(--line)" }}>
      {featured.map((c, ci) => {
        const n = ci + 1;
        const f = (k) => `main.case${n}_${k}`;        // 字段路径
        const v = (k) => t(`main.case${n}_${k}`);      // 当前语言值
        return (
        <div key={ci} style={{
          background: "var(--bg-1)",
          padding: 40,
          display: "flex", flexDirection: "column",
          transition: "background .4s",
        }}
        onMouseEnter={e => e.currentTarget.style.background = "var(--bg-2)"}
        onMouseLeave={e => e.currentTarget.style.background = "var(--bg-1)"}
        >
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 32 }}>
            <span className="mono" data-cpath-fixed={f("ticker")} style={{ color: "var(--gold-soft)" }}>{v("ticker")}</span>
            <span className="mono" data-cpath-fixed={f("year")} style={{ color: "var(--mute-2)" }}>{v("year")}</span>
          </div>
          <div data-cpath-fixed={f("glyph")} style={{
            height: 100,
            border: "1px solid var(--line)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontFamily: "var(--f-serif-cn)",
            fontSize: 32,
            color: "var(--ivory)",
            letterSpacing: "0.08em",
            background: "linear-gradient(135deg, var(--bg-0), var(--bg-2))",
            marginBottom: 32,
          }}>
            {v("glyph")}
          </div>
          <div data-cpath-fixed={f("title")} style={{ fontFamily: "var(--f-serif-cn)", fontSize: 22, fontWeight: 500 }}>{v("title")}</div>
          <div className="serif-en" data-cpath-fixed={`main.caseSub${n}`} style={{ color: "var(--mute)", fontSize: 14, marginTop: 4 }}>{t('main.caseSub' + n)}</div>
          <p data-cpath-fixed={f("desc")} style={{ color: "var(--mute)", fontSize: 15, marginTop: 16, lineHeight: 1.7, flex: 1 }}>{v("desc")}</p>
          <div style={{ marginTop: "auto", paddingTop: 24, borderTop: "1px solid var(--line-2)", display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
            <span className="mono" data-cpath-fixed={f("market")} style={{ color: "var(--mute-2)", letterSpacing: "0.08em" }}>{v("market")}</span>
            {v("ret") && (
              <span style={{ fontFamily: "var(--f-serif-en)", fontSize: 30, color: "var(--gold)" }}>
                <span data-cpath-fixed={f("ret")}>{v("ret")}</span><span data-cpath-fixed={f("retLabel")} style={{ fontSize: 14, color: "var(--mute)", marginLeft: 4, fontStyle: "italic" }}>{v("retLabel")}</span>
              </span>
            )}
          </div>
        </div>
        );
      })}
    </div>
  );
}

// =========================================================
// ABOUT — Company story + Team
// =========================================================
function AboutPage({ lang, setRoute }) {
  const t = (keyOrCn, en) => {
    if (typeof keyOrCn === "string" && keyOrCn.indexOf(".") > 0 && window.I18N) {
      const [ns, k] = keyOrCn.split(".", 2);
      const val = window.I18N[lang] && window.I18N[lang][ns] && window.I18N[lang][ns][k];
      if (val !== undefined) return val;
    }
    // fallback: 兼容旧 t(cn, en) 调用
    return lang === "cn" ? keyOrCn : (en !== undefined ? en : keyOrCn);
  };
  return (
    <div className="page" data-screen-label="02 About">
      {/* Hero */}
      <section style={{ paddingTop: "calc(var(--nav-h) + 120px)", paddingBottom: 80 }}>
        <div className="container-wide">
          <div className="eyebrow" style={{ marginBottom: 24 }}>{t('main.t033')}</div>
          <h1 className="h-display" style={{ whiteSpace: "nowrap" }}>
            {t('main.t034')}
          </h1>
          <h1 className="h-display" style={{ whiteSpace: "nowrap" }}>
            <span style={{ color: "var(--gold)" }}>{t('main.t035')}</span>
          </h1>
        </div>
      </section>

      {/* Image + intro */}
      <section className="section-tight">
        <div className="container-wide" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 80, alignItems: "stretch" }}>
          <EditableImage
            url={D.about?.heroImage?.url} fit={D.about?.heroImage?.fit}
            cpath="site_data.about.heroImage"
            label={t('main.t036')} kind="skyline" style={{ minHeight: 540 }} />
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "center" }}>
            <div className="eyebrow-mute">{t('main.t037')}</div>
            <p className="body-lg" style={{ marginTop: 24, lineHeight: 1.8 }}>
              {t('main.t038')}
            </p>
            <p className="body-mute" style={{ marginTop: 24 }}>
              {t('main.t039')}
            </p>
            <div style={{ marginTop: 40, display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
              {[
                { l: t('main.t040'), v: t('main.foundDate'), vKey: "main.foundDate" },
                { l: t('main.t041'), v: t('main.regCode'), vKey: "main.regCode" },
                { l: t('main.t042'), v: t('main.yearsCount'), vKey: "main.yearsCount" },
                { l: t('main.t009'), v: t('main.t043') },
              ].map((k, i) => (
                <div key={i} style={{ borderTop: "1px solid var(--line)", paddingTop: 16 }}>
                  <div className="mono" style={{ color: "var(--mute-2)", fontSize: 10, letterSpacing: "0.14em" }}>{k.l.toUpperCase()}</div>
                  <div style={{ fontFamily: "var(--f-serif-cn)", fontSize: 22, color: "var(--gold)", marginTop: 6 }}
                    {...(k.vKey ? { "data-cpath-fixed": k.vKey } : {})}>{k.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="section" style={{ background: "var(--bg-0)" }}>
        <div className="container-wide">
          <SectionHead
            lang={lang}
            num={t('main.num06')}
            kicker={t('main.kMilestones')}
            title={t('main.t044')}
            lead={t('main.t045')}
          />
          <div className="tl" data-cms-list="timeline" data-cms-list-dir="vertical">
            {D.timeline.map((m, i) => (
              <div className="tl-item" key={m.yr} data-cms-list-item={i}>
                <div className="tl-yr">{m.yr}</div>
                <div className="tl-title">{lang === "cn" ? m.titleCn : m.titleEn}</div>
                <div className="tl-body">{lang === "cn" ? m.body.cn : m.body.en}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="section">
        <div className="container-wide">
          <SectionHead
            lang={lang}
            num={t('main.num07')}
            kicker={t('main.kTheTeam')}
            title={t('main.t046')}
            lead={t('main.t047')}
          />
          <div className="team-grid" data-cms-list="team" data-cms-list-dir="horizontal">
            {D.team.map((m, i) => (
              <div className="team-card" key={i} data-cms-list-item={i}>
                <div className={`team-portrait${m.photo?.url ? " has-pic" : ""}`} data-name={m.photo?.url ? undefined : m.glyph}
                  data-cms-image={`site_data.team.${i}.photo`}>
                  {m.photo?.url
                    ? <img src={fileUrlMain(m.photo.url)} alt={lang === "cn" ? m.cn : m.en}
                        onClick={() => zoomImage(fileUrlMain(m.photo.url))}
                        style={m.photo.fit === "height"
                          ? { width: "100%", height: "100%", objectFit: "cover", display: "block", cursor: "zoom-in" }
                          : { width: "100%", height: "auto", display: "block", cursor: "zoom-in" }} />
                    : <div className="ph-label">{t('main.t048')}</div>}
                </div>
                <div className="team-name">{lang === "cn" ? m.cn : m.en}</div>
                <div className="team-role">{lang === "cn" ? m.role.cn : m.role.en}</div>
                <div className="team-bio">{lang === "cn" ? m.bio.cn : m.bio.en}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Quote / Culture */}
      <section style={{ padding: "160px 0", background: "var(--bg-0)", borderTop: "1px solid var(--line)" }}>
        <div className="container" style={{ textAlign: "center" }}>
          <div style={{ fontFamily: "var(--f-serif-en)", fontSize: 80, color: "var(--gold)", lineHeight: 0.5 }}>"</div>
          <p className="h-2" style={{ maxWidth: 720, margin: "32px auto 0", fontWeight: 400 }}>
            {t('main.t049')}
          </p>
          <div className="mono" style={{ color: "var(--gold)", marginTop: 32, letterSpacing: "0.14em" }}>
            — {t('main.t050')}
          </div>
        </div>
      </section>
    </div>
  );
}

// =========================================================
// STRATEGY
// =========================================================
function StrategyPage({ lang, setRoute, nested }) {
  const t = (keyOrCn, en) => {
    if (typeof keyOrCn === "string" && keyOrCn.indexOf(".") > 0 && window.I18N) {
      const [ns, k] = keyOrCn.split(".", 2);
      const val = window.I18N[lang] && window.I18N[lang][ns] && window.I18N[lang][ns][k];
      if (val !== undefined) return val;
    }
    // fallback: 兼容旧 t(cn, en) 调用
    return lang === "cn" ? keyOrCn : (en !== undefined ? en : keyOrCn);
  };
  return (
    <div className={nested ? "" : "page"} data-screen-label={nested ? undefined : "03 Strategy"}>
      {!nested && <InvestTabs route="strategy" setRoute={setRoute} lang={lang} />}
      {!nested && (
      <section style={{ paddingTop: 60, paddingBottom: 80 }}>
        <div className="container-wide">
          <div className="eyebrow" style={{ marginBottom: 24 }}>{t('main.t051')}</div>
          <h1 className="h-display">{t('main.t052')}</h1>
          <h1 className="h-display">
            {lang === "cn"
              ? <span data-cpath-fixed="main.t052b" style={{ color: "var(--gold)" }}>{t('main.t052b')}</span>
              : <span data-cpath-fixed="main.t052b" className="serif-en" style={{ color: "var(--gold)" }}>{t('main.t052b')}</span>}
          </h1>
          <p className="body-lg body-mute" style={{ maxWidth: 720, marginTop: 36 }}>
            {t('main.t053')}
          </p>
        </div>
      </section>
      )}

      {/* Stage focus */}
      <section className="section-tight">
        <div className="container-wide">
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 60 }}>
            <div className="strategy-stage-card strategy-stage-card-a">
              <div className="mono" data-cpath-fixed="main.stKickA" style={{ color: "var(--gold)" }}>{t('main.stKickA')}</div>
              <h3 className="h-2" style={{ marginTop: 20 }}>{t('main.t054')}</h3>
              <p className="body-mute" style={{ marginTop: 16, fontSize: 15 }}>
                {t('main.t055')}
              </p>
              <div style={{ marginTop: 32, display: "flex", flexWrap: "wrap", gap: 8 }}>
                <span data-cpath-fixed="main.stTagsA" style={{ fontSize: 11, color: "var(--gold)", padding: "6px 12px", border: "1px solid var(--line)", fontFamily: "var(--f-mono)", letterSpacing: "0.08em" }}>{t('main.stTagsA')}</span>
              </div>
            </div>
            <div className="strategy-stage-card strategy-stage-card-b">
              <div className="mono" data-cpath-fixed="main.stKickB" style={{ color: "var(--gold)" }}>{t('main.stKickB')}</div>
              <h3 className="h-2" style={{ marginTop: 20 }}>{t('main.t056')}</h3>
              <p className="body-mute" style={{ marginTop: 16, fontSize: 15 }}>
                {t('main.t057')}
              </p>
              <div style={{ marginTop: 32, display: "flex", flexWrap: "wrap", gap: 8 }}>
                <span data-cpath-fixed="main.stTagsB" style={{ fontSize: 11, color: "var(--gold)", padding: "6px 12px", border: "1px solid var(--line)", fontFamily: "var(--f-mono)", letterSpacing: "0.08em" }}>{t('main.stTagsB')}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sectors full */}
      <section className="section">
        <div className="container-wide">
          <SectionHead
            lang={lang}
            num={t('main.num08')}
            kicker={<span data-cpath-fixed="main.stFourKicker">{t('main.stFourKicker')}</span>}
            title={t('main.t058')}
          />
          <div className="sector-grid">
            {D.sectors.map((s, si) => (
              <div className="sector-cell" key={s.num} style={{ minHeight: 320 }}>
                <div className="num">— {s.num}</div>
                <div className="name" data-cpath-fixed={`main.stTrack${si + 1}Cn`}>{t('main.stTrack' + (si + 1) + 'Cn')}</div>
                {lang === "cn" && <div className="name-en" data-cpath-fixed={`main.stTrack${si + 1}Sub`}>{t('main.stTrack' + (si + 1) + 'Sub')}</div>}
                <div className="desc">{lang === "cn" ? s.desc.cn : s.desc.en}</div>
                <div className="examples" data-cpath-fixed={`main.stTrack${si + 1}Ex`}>
                  {t('main.stTrack' + (si + 1) + 'Ex')}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Philosophy */}
      <section className="section" style={{ background: "var(--bg-0)" }}>
        <div className="container-wide">
          <SectionHead
            lang={lang}
            num={t('main.num09')}
            kicker="PHILOSOPHY"
            title={t('main.t059')}
          />
          <div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 0 }}>
            {D.philosophy.map((p, i) => (
              <div key={p.num} style={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 1fr",
                gap: 60,
                padding: "48px 0",
                borderTop: "1px solid var(--line)",
                borderBottom: i === D.philosophy.length - 1 ? "1px solid var(--line)" : "none",
                alignItems: "start",
              }}>
                <div data-cpath-fixed={`main.stPhilo${i + 1}Num`} style={{ fontFamily: "var(--f-serif-en)", fontSize: 64, color: "var(--gold)", fontStyle: "italic", lineHeight: 0.9 }}>{t('main.stPhilo' + (i + 1) + 'Num')}</div>
                <div>
                  <div style={{ fontFamily: "var(--f-serif-cn)", fontSize: 32, fontWeight: 500 }}>{lang === "cn" ? p.cn : p.en}</div>
                  {lang === "cn" && <div className="serif-en" style={{ color: "var(--gold)", fontSize: 18, marginTop: 6 }}>{p.en}</div>}
                </div>
                <p style={{ color: "var(--mute)", fontSize: 16, lineHeight: 1.8, paddingTop: 8 }}>{lang === "cn" ? p.body.cn : p.body.en}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="section">
        <div className="container" style={{ textAlign: "center" }}>
          <h2 className="h-1">{t('main.t060')}</h2>
          <p className="body-lg body-mute" style={{ marginTop: 24, maxWidth: 600, margin: "24px auto 40px" }}>
            {t('main.t061')}
          </p>
          <button className="btn" onClick={() => setRoute("portfolio")} style={{ margin: "0 auto" }}>
            {t('main.t062')}<span className="arr"></span>
          </button>
        </div>
      </section>
    </div>
  );
}

Object.assign(window, { HomePage, AboutPage, StrategyPage, FeaturedCases });
